export const onMemoryBoostQuizCompleted = (data, get) => {
  const { resultsBreakdown, currentStreak, longestStreak, canBoost } = data;
  get().setMemoryBoost({
    resultsBreakdown,
    currentStreak,
    longestStreak,
    canBoost,
  });
};
